module.exports = __webpack_public_path__ + "img/kelso-beige.9e0d4e6.webp";